var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19C6.38 12.683 12.814 6.316 19.195 0l3.839 3.8-12.641 12.513H48v5.374H10.392L23.034 34.2l-3.84 3.8L0 19Z"
  })));
};
export default SvgArrowBack;